// web/dyno-pwa/src/demo/websocket.ts
import { buildDynoSamples, buildDynoSnapshot } from "./engine";

const TICK_MS = 1000;

export class DemoWebSocket {
  static readonly CONNECTING = 0; static readonly OPEN = 1; static readonly CLOSING = 2; static readonly CLOSED = 3;
  readonly CONNECTING = 0; readonly OPEN = 1; readonly CLOSING = 2; readonly CLOSED = 3;
  url: string; readyState = 0; binaryType: BinaryType = "blob";
  onopen: ((ev: Event) => void) | null = null;
  onmessage: ((ev: MessageEvent) => void) | null = null;
  onclose: ((ev: CloseEvent) => void) | null = null;
  onerror: ((ev: Event) => void) | null = null;
  private _timer: ReturnType<typeof setTimeout> | null = null;
  private _tickCount = 0;

  constructor(url: string) {
    this.url = String(url);
    const isRealtime = this.url.includes("/api/ws/realtime");
    setTimeout(() => {
      if (!isRealtime) { this.readyState = 3; this.onclose?.({} as CloseEvent); return; }
      this.readyState = 1;
      this.onopen?.({} as Event);
      this._tick();
    }, 80);
  }
  private _tick(): void {
    if (this.readyState !== 1) return;
    try {
      const now = Date.now();
      this.onmessage?.({ data: JSON.stringify(buildDynoSamples(now)) } as MessageEvent);
      if (this._tickCount % 5 === 0) this.onmessage?.({ data: JSON.stringify(buildDynoSnapshot(now)) } as MessageEvent);
      this._tickCount++;
    } catch (err) { console.warn("[demo] ws tick error", err); }
    this._timer = setTimeout(() => this._tick(), TICK_MS);
  }
  send(_data: unknown): void { /* client subscribe — ignored */ }
  close(): void { this.readyState = 3; if (this._timer) clearTimeout(this._timer); this.onclose?.({} as CloseEvent); }
  addEventListener(type: string, cb: (ev: any) => void): void {
    if (type === "open") this.onopen = cb; else if (type === "message") this.onmessage = cb;
    else if (type === "close") this.onclose = cb; else if (type === "error") this.onerror = cb;
  }
  removeEventListener(type: string): void {
    if (type === "open") this.onopen = null; else if (type === "message") this.onmessage = null;
    else if (type === "close") this.onclose = null; else if (type === "error") this.onerror = null;
  }
}
